// Dźwięk powiadomień — ustawienia per przeglądarka (localStorage) + odtwarzanie.
// Używane przez czat (chatNotifications) i Ustawienia konta (podgląd/konfiguracja).

const KEY = 'notifSoundSettings';

// klasyczny dzwonek czatu (WAV wbudowany — bez zewnętrznych plików)
const CLASSIC_WAV = 'data:audio/wav;base64,UklGRmQGAABXQVZFZm10IBAAAAABAAEAQB8AAEAfAAABAAgAZGF0YUAGAAB/wOPYpGApGzp5uuHaqmYuGzZytd7cr2wyHDJsr9vdtHM3HS9nqdjeuXk8Hi1ho9TevX9BICpbndDfwYVHIihWl8zexYtMJSdRkcjeyJFSJyVNi8Pdy5ZXKiVIhb/bzZxdLiREf7rZ0KFjMiRAebXX0qZoNSQ9dLDV06puOiU6bqrS1K90PiY3aaXP1bN5Qic0ZJ/M1bd/RykyX5rJ1buETCsxWpXF1b6KUS0vVo/B1cGPVjAuUYq91MSUWzMtTYS50caZYDYtSn+00cieZTktRnqwz8qiazwtQ3WrzcumcEAuQHCmysyqdUQuPmuhyM2uekgwPGacxc2yf0wxOmKXws21hFEzOF6Svs24iVU1N1qOu8y7jVo3NlaJt8y9kl46NVKEs8q/lmM9NU9/r8nBm2hANUx6q8fDn2xDNUl2p8XEo3FGNUZxosPFpnZKNkRtnsHFqnpNN0Jpmr7GrX9ROUBllbvGsINVOj9hkbjGs4hZPD5djLXFtYxdPj1aiLLEt5BiQDxWg67DuZRmQzxTf6vCu5hqRjxRe6fBvJxuSTxOd6O/vZ9yTDxMc5+9vqN3Tz1Kb5u7v6Z7Uj5Ia5e4v6h/Vj9GZ5O2v6uDWUFFZI+zv66HXUJEYIuwvrCLYURDXYetvrKPZEZCWoOqvbSSaElCWH+mvLWWbEtCVXujuraZcE5CU3egubecdFBDUXSct7ifd1NDT3CYtbmie1ZETW2Vs7mlf1pFTGmRsLmng11HSmaNrrmphmBISWOKq7irimNKSWCGqbitjWdMSF6DprevkGpOSFt/o7awlG5QSFl8oLWxl3FSSFd4nLOymXVVSFV1mbKznHhYSVNylrCzn3xaSlJuk66zoX9dS1Brj6yzo4JgTE9pjKmzpYZjTU9miaezp4lmT05jhaWyqYxpUU1hgqKyqo9sUk1ff5+xq5JvVE1dfJywrJRzV01beZqurZd2WU5Zdpetrpl5W05Xc5Srrpx8Xk9WcJGprp5/YFBVbY6nrqCCY1FUa4ulrqKFZlJTaIijrqOIaFNTZoWhraWLa1VSZIKfraaNbldSYn+crKePcVlSYHycq6iRdFtSXnqaq6mUd11SXHeYqqqXel9TW3SVqKqafGFTWXGSpqqdgGNUV26PpKqgg2ZUWG2MoqmihWlVVmuJoKmkiGxXVWmHnqilim9YVGeDnKimjXJaVGWBmqaojnRcVGN/mKWokHddVGF8lqSqk3lfVV96lKOqlXxhVV14kqGqmH5jVlt2kKCqmoFlV1pzjp6qnINnWFhxjJyqnoVpWVdvi5qpn4hqWlZtiZipoYttW1Vrh5aoootv';

export const SOUND_OPTIONS = [
  { text: 'Klasyczny', value: 'klasyczny' },
  { text: 'Dzwonek', value: 'dzwonek' },
  { text: 'Pop', value: 'pop' },
  { text: 'Tryl', value: 'tryl' },
  { text: 'Brak dźwięku', value: 'brak' },
];

export function getSoundSettings() {
  const def = { sound: 'klasyczny', volume: 50 };
  try {
    return { ...def, ...(JSON.parse(localStorage.getItem(KEY)) || {}) };
  } catch {
    return def;
  }
}

export function saveSoundSettings(settings) {
  localStorage.setItem(KEY, JSON.stringify(settings));
}

// Syntezowane dźwięki przez WebAudio — zero plików, głośność 0..1.
function synth(kind, volume) {
  const Ctx = window.AudioContext || window.webkitAudioContext;
  if (!Ctx) return;
  const ctx = new Ctx();
  const master = ctx.createGain();
  master.gain.value = volume;
  master.connect(ctx.destination);
  const tone = (freq, start, dur, type = 'sine', peak = 1) => {
    const o = ctx.createOscillator();
    const g = ctx.createGain();
    o.type = type;
    o.frequency.value = freq;
    g.gain.setValueAtTime(0, ctx.currentTime + start);
    g.gain.linearRampToValueAtTime(peak, ctx.currentTime + start + 0.01);
    g.gain.exponentialRampToValueAtTime(0.001, ctx.currentTime + start + dur);
    o.connect(g);
    g.connect(master);
    o.start(ctx.currentTime + start);
    o.stop(ctx.currentTime + start + dur + 0.05);
  };
  if (kind === 'dzwonek') {
    tone(880, 0, 0.45, 'sine', 0.9);
    tone(1320, 0.02, 0.4, 'sine', 0.4);
  } else if (kind === 'pop') {
    tone(520, 0, 0.12, 'triangle', 1);
  } else if (kind === 'tryl') {
    tone(660, 0, 0.12, 'sine', 0.8);
    tone(880, 0.13, 0.12, 'sine', 0.8);
    tone(1100, 0.26, 0.2, 'sine', 0.8);
  }
  setTimeout(() => ctx.close().catch(() => {}), 1500);
}

/** Odtwarza dźwięk powiadomienia wg ustawień (lub podanych — do próbki). */
export function playNotifSound(override) {
  const { sound, volume } = override || getSoundSettings();
  if (sound === 'brak' || !volume) return;
  const vol = Math.min(1, Math.max(0, volume / 100));
  try {
    if (sound === 'klasyczny') {
      const audio = new Audio(CLASSIC_WAV);
      audio.volume = vol;
      audio.play().catch(() => {});
    } else {
      synth(sound, vol);
    }
  } catch (e) {
    /* dźwięk nie może blokować niczego */
  }
}
